import { cardImageSources, type GenericCharacter } from './types'

export const genericElfo: GenericCharacter = {
  id: 'generic-elfo',
  enabled: true,
  order: 12,
  displayName: 'Tobi',
  icon: '🧝',
  imageSources: cardImageSources('generic-elfo'),
}
